import React, { useEffect, useState } from 'react';
import GlobalModal from 'components/globalModal';
import { assignChildPartner, getRequestData } from 'api/api';
import { endpoints } from 'api/endpoints';
import { ROLE_TYPES, SLH_TYPES } from 'api/constants';
import { Checkbox, Input } from 'antd';
import { IconSearch } from 'components/icons/Search';
import { COLORS } from 'utils/colors';
import { IconChild, IconPlus, OrangeButton, SmallButton } from 'components';
import { useNavigate } from 'react-router-dom';

export const AddChildToParentModal = ({ onSuccess, onClose, isOpen, partnerID }) => {
  const navigate = useNavigate();
  const [partnersList, setPartnersList] = useState([]);
  const [filteredPartnersList, setFilteredPartnersList] = useState([]);
  const [selectedChilds, setSelectedChilds] = useState([]);
  const [searchWord, setSearchWord] = useState('');

  useEffect(() => {
    (async () => {
      const { data } = await getRequestData(
        endpoints.getAllPartners(SLH_TYPES.child),
        ROLE_TYPES.admin,
      );
      if (data) setPartnersList(data);
    })();
  }, []);

  const onSearch = (e) => {
    const searchTerm = e.target.value;

    const filteredPartners = partnersList.filter((partner) =>
      partner.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );

    setFilteredPartnersList(filteredPartners);
    setSearchWord(searchTerm);
  };

  const handleCheckboxChange = (childId) => {
    setSelectedChilds(childId);
  };

  const handleSubmit = async () => {
    const payload = {
      parentId: partnerID,
      childId: selectedChilds,
    };
    await assignChildPartner(ROLE_TYPES.admin, payload, () => onSuccess());
  };

  const renderPartnersList = () => {
    if (!partnersList || !Array.isArray(partnersList)) return <div>No partners found.</div>;

    const partnersToDisplay =
      filteredPartnersList.length > 0 || searchWord ? filteredPartnersList : partnersList;

    return (
      <Checkbox.Group
        onChange={handleCheckboxChange}
        className="w-full flex lex-col gap-y-2 max-h-[290px] overflow-y-auto"
      >
        {partnersToDisplay.map((partner) => (
          <Checkbox
            key={partner.id}
            checked={selectedChilds.includes(partner.id)}
            className="w-full px-4 py-2.5 bg-white border font-medium rounded-xl gap-x-2"
            value={partner.id}
          >
            <div className="flex items-center gap-x-2">
              <IconChild />
              {partner.name}
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
    );
  };

  return (
    <GlobalModal
      width={510}
      open={isOpen}
      title="Add Child SLH"
      onClose={() => {
        onClose();
        setSelectedChilds([]);
        setFilteredPartnersList([]);
        setSearchWord('');
      }}
      titleLeft
    >
      <div className="flex flex-col gap-y-4 mt-4 px-8 pb-8">
        <Input
          className="search text-lightBlue text-16 rounded-ten bg-light"
          type="text"
          placeholder="Search"
          addonBefore={<IconSearch color={COLORS.lightBlue} />}
          onChange={onSearch}
        />
        <div className="flex flex-col gap-y-2">{renderPartnersList()}</div>
        <div className="flex justify-between">
          <div className="flex flex-col gap-y-1">
            <p className="text-14 text-lightBlue">Can’t find in the list?</p>
            <SmallButton
              icon={<IconPlus color={COLORS.blue} />}
              label="Create new child"
              onClick={() => navigate('/create-partner')}
              className="mb-2"
            />
          </div>
          <OrangeButton onClick={handleSubmit} label="Save" className="self-end" />
        </div>
      </div>
    </GlobalModal>
  );
};
